import React from 'react'
import Carousel from '../Carousel/Carousel'
import './Intro.css'
import DetectIOSWrapper from './DetectIOSWrapper'

const Intro = ({setShowIntro}) => {
  return (
    <div className='Intro'>
      <DetectIOSWrapper />
           <Carousel setShowIntro={setShowIntro}/>
    </div>
  )
}

export default Intro